import { ToolTipOptionSelectActiveOutputWithStatus } from './tool-tip-option-select-active-output-with-status.model';


export class ToolTipOptionSelectByIdOutput implements IToolTipOptionSelectByIdOutput {
    status!: number;
    message!: string;
    data!: ToolTipOptionSelectActiveOutputWithStatus;

    constructor(data?: IToolTipOptionSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? ToolTipOptionSelectActiveOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ToolTipOptionSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipOptionSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IToolTipOptionSelectByIdOutput {
    status: number;
    message: string;
    data: ToolTipOptionSelectActiveOutputWithStatus;
}

